import React from 'react';
import './TextInput.css';

export interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  name?: string;
  type?: string;
  value?: string | number;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  variant?: 'default' | 'modal';
  label?: string;
  hint?: string;
  labelClassName?: string;
  hintClassName?: string;
}

/**
 * Reusable TextInput component with label and hint support
 */
const TextInput: React.FC<TextInputProps> = ({
  id,
  type = 'text',
  placeholder,
  disabled = false,
  required = false,
  className = '',
  variant = 'default',
  label,
  hint,
  labelClassName = '',
  hintClassName = '',
  ...rest
}) => {
  const baseClass = `common-textinput common-textinput--${variant}`;
  const inputClassName = className ? `${baseClass} ${className}` : baseClass;
  
  const labelClass = variant === 'modal' 
    ? `common-textinput__label ${labelClassName}`.trim()
    : `common-textinput__label common-textinput__label--default ${labelClassName}`.trim();
  
  const hintClass = variant === 'modal'
    ? `common-textinput__hint ${hintClassName}`.trim()
    : `common-textinput__hint common-textinput__hint--default ${hintClassName}`.trim();

  const inputElement = (
    <input
      id={id}
      type={type}
      disabled={disabled}
      required={required}
      placeholder={placeholder}
      className={inputClassName}
      {...rest}
    />
  );

  // If label or hint is provided, wrap in a container
  if (label || hint) {
    return (
      <div className="common-textinput__wrapper">
        {label && (
          <label htmlFor={id} className={labelClass}>
            {label}
          </label>
        )}
        {inputElement}
        {hint && (
          <small className={hintClass}>
            {hint}
          </small>
        )}
      </div>
    );
  }

  // Otherwise, return just the input element
  return inputElement;
};

export default TextInput;

